export const CASH_EVIDENCE_MAX_FILE_MB = 20
const MAX_EVIDENCE_LENGTH = 600000

export function cashEvidence(file) {
  return new Promise((resolve, reject) => {
    if (!file || !["image/jpeg", "image/png"].includes(file.type) || !file.size || file.size > CASH_EVIDENCE_MAX_FILE_MB * 1024 * 1024) return reject(new Error(`Bitte ein JPEG- oder PNG-Belegfoto bis ${CASH_EVIDENCE_MAX_FILE_MB} MB waehlen.`))
    const url = URL.createObjectURL(file), image = new Image()
    const done = () => URL.revokeObjectURL(url)
    image.onerror = () => { done(); reject(new Error("Das Belegfoto konnte nicht gelesen werden.")) }
    image.onload = () => {
      try {
        if (!image.width || !image.height) throw new Error("Das Belegfoto konnte nicht gelesen werden.")
        const canvas = document.createElement("canvas"), context = canvas.getContext("2d")
        if (!context) throw new Error("Das Belegfoto konnte nicht verarbeitet werden. Bitte erneut versuchen.")
        // Keep the private stored evidence within the existing server limit.
        // Preserve resolution first, then reduce dimensions only when necessary.
        for (const maxEdge of [1800, 1440, 1152]) {
          const scale = Math.min(1, maxEdge / Math.max(image.width, image.height))
          canvas.width = Math.max(1, Math.round(image.width * scale)); canvas.height = Math.max(1, Math.round(image.height * scale))
          context.fillStyle = "#fff"; context.fillRect(0, 0, canvas.width, canvas.height); context.drawImage(image, 0, 0, canvas.width, canvas.height)
          for (const quality of [.8, .7, .6]) {
            const data = canvas.toDataURL("image/jpeg", quality)
            if (!data.startsWith("data:image/jpeg;base64,")) throw new Error("Das Belegfoto konnte nicht verarbeitet werden. Bitte erneut versuchen.")
            if (data.length <= MAX_EVIDENCE_LENGTH) { resolve(data); return }
          }
        }
        throw new Error("Das Belegfoto konnte nicht ausreichend verkleinert werden. Bitte nur den Beleg fotografieren.")
      } catch (error) { reject(error) } finally { done() }
    }
    image.src = url
  })
}
